export default {
  hello: 'Hello, world!',
};
